import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth, db } from '../../firebase'
import emailjs from '@emailjs/browser'
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../AuthContext/AuthContext'
import '../sign-in/signIn.css'
import { doc, getDoc } from 'firebase/firestore'

function SignIn() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [step, setStep] = useState(1)
  const [generatedCode, setGeneratedCode] = useState('')
  const [inputCode, setInputCode] = useState('')

  const { confirm2FA } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from || '/premium'

  const login = async () => {
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password)

      const code = Math.floor(100000 + Math.random() * 900000).toString()
      setGeneratedCode(code)

      await emailjs.send(
        'service_ewqdm6x',
        'template_mkufs1r',
        { to_email: email.trim(), code },
        'O96gMGMPDaCA5XLVv'
      )

      setStep(2)
      alert('Код отправлен на почту 📩')
    } catch (error) {
      console.log('AUTH ERROR:', error.code, error.message)
      alert(error.code)
    }
  }

  const verifyCode = async () => {
    if (inputCode === generatedCode) {
      confirm2FA()

      const docSnap = await getDoc(doc(db, 'users', auth.currentUser.uid))
      let role = 'student'
      if (docSnap.exists()) role = docSnap.data().role

      if (role === 'admin') navigate('/admin', { replace: true })
      else navigate(from, { replace: true })
    } else {
      alert('Неверный код ❌')
    }
  }

  return (
    <div className="signIn-container">
      <div className="signIn-control">
        {step === 1 && (
          <div className="signIn-elements">
            <h2>Вход</h2>
            <div className="signIn-input-btn-control">
              <input placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
              <input
                type="password"
                placeholder="Пароль"
                onChange={(e) => setPassword(e.target.value)}
              />
              <button onClick={login}>Войти</button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="signIn-elements">
            <h2>Введите код</h2>
            <div className="signIn-input-btn-control">
              <input placeholder="Код из email" onChange={(e) => setInputCode(e.target.value)} />
              <button onClick={verifyCode}>Подтвердить</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default SignIn
